import React from 'react'
import RenderOnRole from '../../../../components/RenderOnRole'
import { HISTORY_READ, HISTORY_WRITE } from '../../../../utils/roles'
import Vitals from '../Vitals'

const VitalsPhysio = () => {
  return (
    <RenderOnRole
      roles={[HISTORY_READ, HISTORY_WRITE]}
      element={<Vitals intent='vitalsPhysio' />}
    />
  )
}

export default VitalsPhysio
